var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Checkbox, Col, ErrorModal, Loading, MessageBanner, Row, TextField, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { fetchIssnRegisterStatus, triggerIssnRegisterRun, updateIssnRegisterSchedule, } from "../../api/adminService";
import { elapsedMs, extractErrorMessage, formatDateTime, formatDuration, fromDateInputValue, hasHttpStatus, toDateInputValue, } from "../../utils/adminJobUtils";
import { RecekDatepicker } from "../inputs/RecekDatepicker";
import styles from "./SolrAdmin.module.css";
var ISSN_REGISTER_STATUS_QUERY_KEY = ["issnRegisterStatus"];
var STATUS_REFRESH_MS = 5000;
var MSG = "ui-br-agency.admin.issn-register";
/** The current time, ticking every second while `active` (the elapsed time of a running harvest). */
var useNow = function (active) {
    var _a = useState(function () { return Date.now(); }), now = _a[0], setNow = _a[1];
    useEffect(function () {
        if (!active)
            return undefined;
        setNow(Date.now());
        var timer = setInterval(function () { return setNow(Date.now()); }, 1000);
        return function () { return clearInterval(timer); };
    }, [active]);
    return now;
};
var StatRow = function (_a) {
    var labelId = _a.labelId, children = _a.children;
    return (React.createElement("tr", null,
        React.createElement("th", null,
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".").concat(labelId) })),
        React.createElement("td", null, children)));
};
/** Rows shared by the current and the last finished run: how it was started and what it did so far. */
var RunRows = function (_a) {
    var run = _a.run;
    return (React.createElement(React.Fragment, null,
        React.createElement(StatRow, { labelId: "run.trigger" },
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".trigger.").concat(run.trigger) })),
        React.createElement(StatRow, { labelId: "run.mode" }, run.fullHarvest || !run.harvestFrom ? (React.createElement(FormattedMessage, { id: "".concat(MSG, ".run.mode.full") })) : (React.createElement(FormattedMessage, { id: "".concat(MSG, ".run.mode.incremental"), values: { date: formatDateTime(run.harvestFrom) } }))),
        React.createElement(StatRow, { labelId: "run.startedAt" }, formatDateTime(run.startedAt))));
};
var CountRows = function (_a) {
    var run = _a.run;
    return (React.createElement(React.Fragment, null,
        React.createElement(StatRow, { labelId: "run.pages" }, run.pages),
        React.createElement(StatRow, { labelId: "run.totalRecords" }, run.totalRecords),
        React.createElement(StatRow, { labelId: "run.registered" },
            run.registered,
            " (",
            run.yearbooksRegistered,
            ")"),
        React.createElement(StatRow, { labelId: "run.created" },
            run.editionsCreated,
            " / ",
            run.yearbooksCreated),
        React.createElement(StatRow, { labelId: "run.updated" }, run.editionsUpdated),
        React.createElement(StatRow, { labelId: "run.skipped" },
            run.editionsSkipped,
            " / ",
            run.yearbooksSkipped),
        React.createElement(StatRow, { labelId: "run.deleted" }, run.deletedRecords),
        React.createElement(StatRow, { labelId: "run.other" }, run.otherRecords),
        React.createElement(StatRow, { labelId: "run.invalid" }, run.invalidRecords)));
};
var CurrentRun = function (_a) {
    var run = _a.run;
    var now = useNow(true);
    return (React.createElement("table", { className: styles.statsTable, "aria-labelledby": "issn-current-run" },
        React.createElement("tbody", null,
            React.createElement(StatRow, { labelId: "run.status" },
                React.createElement("span", { className: styles.runningBadge },
                    React.createElement(FormattedMessage, { id: "".concat(MSG, ".status.RUNNING") }))),
            React.createElement(RunRows, { run: run }),
            React.createElement(StatRow, { labelId: "currentRun.elapsed" }, formatDuration(elapsedMs(run.startedAt, now))),
            React.createElement(StatRow, { labelId: "currentRun.heartbeat" }, formatDateTime(run.heartbeatAt)),
            React.createElement(CountRows, { run: run }))));
};
var LastRun = function (_a) {
    var run = _a.run;
    return (React.createElement("table", { className: styles.statsTable, "aria-labelledby": "issn-last-run" },
        React.createElement("tbody", null,
            React.createElement(StatRow, { labelId: "run.status" },
                React.createElement(FormattedMessage, { id: "".concat(MSG, ".status.").concat(run.status) })),
            React.createElement(RunRows, { run: run }),
            React.createElement(StatRow, { labelId: "run.finishedAt" }, formatDateTime(run.finishedAt)),
            React.createElement(StatRow, { labelId: "run.duration" }, formatDuration(run.durationMs)),
            React.createElement(CountRows, { run: run }),
            run.errorMessage && (React.createElement(StatRow, { labelId: "run.error" },
                React.createElement("span", { className: styles.unreachableBadge }, run.errorMessage))))));
};
/**
 * Administration of the ISSN register harvest (DB-787): the schedule stored in the database (enabled, cron,
 * harvest-from), the run in progress with its counts so far, the last finished run, manual and full runs.
 */
export var IssnRegisterAdmin = function () {
    var _a, _b, _c;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var queryClient = useQueryClient();
    var _d = useQuery(ISSN_REGISTER_STATUS_QUERY_KEY, function () { return fetchIssnRegisterStatus(ky); }, { refetchInterval: STATUS_REFRESH_MS }), status = _d.data, isLoading = _d.isLoading, error = _d.error;
    var _f = useState(""), cronExpression = _f[0], setCronExpression = _f[1];
    var _g = useState(false), enabled = _g[0], setEnabled = _g[1];
    var _h = useState(""), harvestFrom = _h[0], setHarvestFrom = _h[1];
    // true once the user edited the form: the server values (a completed run advances harvest-from) no longer
    // overwrite it, so saving never silently rewinds or keeps a stale date
    var _j = useState(false), dirty = _j[0], setDirty = _j[1];
    var _k = useState(false), saved = _k[0], setSaved = _k[1];
    var _l = useState(false), errorOpen = _l[0], setErrorOpen = _l[1];
    var _m = useState(null), errorDetail = _m[0], setErrorDetail = _m[1];
    var serverSchedule = status === null || status === void 0 ? void 0 : status.schedule;
    useEffect(function () {
        if (serverSchedule && !dirty) {
            setCronExpression(serverSchedule.cronExpression);
            setEnabled(serverSchedule.enabled);
            setHarvestFrom(toDateInputValue(serverSchedule.harvestFrom));
        }
    }, [serverSchedule, dirty]);
    var edit = function (setter) {
        return function (value) {
            setter(value);
            setDirty(true);
            setSaved(false);
        };
    };
    var showError = function (detail) {
        setErrorDetail(detail);
        setErrorOpen(true);
    };
    var refreshStatus = function () {
        return queryClient.invalidateQueries(ISSN_REGISTER_STATUS_QUERY_KEY);
    };
    var saveMutation = useMutation({
        mutationFn: function () {
            return updateIssnRegisterSchedule(ky, {
                cronExpression: cronExpression,
                enabled: enabled,
                harvestFrom: fromDateInputValue(harvestFrom),
            });
        },
        onSuccess: function (savedSchedule) {
            // the saved values at once, so the form does not flash the previous ones until the refetch
            queryClient.setQueryData(ISSN_REGISTER_STATUS_QUERY_KEY, function (previous) {
                return previous ? __assign(__assign({}, previous), { schedule: savedSchedule }) : previous;
            });
            setDirty(false);
            setSaved(true);
            refreshStatus();
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = showError;
                    return [4 /*yield*/, extractErrorMessage(err)];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        }); }); },
    });
    var runMutation = useMutation({
        mutationFn: function (full) { return triggerIssnRegisterRun(ky, full); },
        onSuccess: refreshStatus,
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // 409: nothing was started - a run is already in progress (maybe on another instance) or none can start now
                        if (hasHttpStatus(err, 409)) {
                            refreshStatus();
                            showError(formatMessage({ id: "".concat(MSG, ".run.notStarted") }));
                            return [2 /*return*/];
                        }
                        _a = showError;
                        return [4 /*yield*/, extractErrorMessage(err)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    if (isLoading && !status) {
        return React.createElement(Loading, null);
    }
    if (error && !status) {
        return (React.createElement("div", null,
            formatMessage({ id: "ui-br-agency.modal.label.error" }),
            ":",
            " ",
            formatMessage({ id: "".concat(MSG, ".error") })));
    }
    var running = (_a = status === null || status === void 0 ? void 0 : status.running) !== null && _a !== void 0 ? _a : false;
    var currentRun = (_b = status === null || status === void 0 ? void 0 : status.currentRun) !== null && _b !== void 0 ? _b : null;
    var lastRun = (_c = status === null || status === void 0 ? void 0 : status.lastRun) !== null && _c !== void 0 ? _c : null;
    var runDisabled = running || runMutation.isLoading;
    return (React.createElement(React.Fragment, null,
        React.createElement(FormattedMessage, { id: "".concat(MSG, ".title"), tagName: "h1" }),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".description") })),
        (status === null || status === void 0 ? void 0 : status.url) && (React.createElement("p", { className: styles.hint },
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".url") }),
            " ",
            status.url)),
        React.createElement(ErrorModal, { label: React.createElement(FormattedMessage, { id: "".concat(MSG, ".title") }), open: errorOpen, content: errorDetail !== null && errorDetail !== void 0 ? errorDetail : formatMessage({ id: "".concat(MSG, ".error") }), onClose: function () { return setErrorOpen(false); } }),
        React.createElement(FormattedMessage, { id: "".concat(MSG, ".schedule.title"), tagName: "h2" }),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(TextField, { label: React.createElement(FormattedMessage, { id: "".concat(MSG, ".schedule.cron") }), value: cronExpression, onChange: function (e) {
                        return edit(setCronExpression)(e.target.value);
                    } })),
            React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(RecekDatepicker, { labelId: "".concat(MSG, ".schedule.harvestFrom"), value: harvestFrom, backendDateStandard: "YYYY-MM-DD", dateFormat: "DD.MM.YYYY", onChange: function (_e, _displayValue, backendValue) {
                        return edit(setHarvestFrom)(backendValue);
                    } })),
            React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(Checkbox, { label: React.createElement(FormattedMessage, { id: "".concat(MSG, ".schedule.enabled") }), checked: enabled, onChange: function (e) {
                        return edit(setEnabled)(e.target.checked);
                    } }))),
        React.createElement("p", { className: styles.hint },
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".schedule.cron.hint") })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".schedule.nextRun") }),
            " ",
            React.createElement("strong", null, formatDateTime(status === null || status === void 0 ? void 0 : status.nextRunAt))),
        React.createElement("div", { className: styles.buttonContainer },
            React.createElement(Button, { buttonStyle: "primary", onClick: function () { return saveMutation.mutate(); }, disabled: saveMutation.isLoading },
                React.createElement(FormattedMessage, { id: "".concat(MSG, ".schedule.save") })),
            React.createElement(Button, { onClick: function () { return runMutation.mutate(false); }, disabled: runDisabled }, running ? (React.createElement(FormattedMessage, { id: "".concat(MSG, ".run.running") })) : (React.createElement(FormattedMessage, { id: "".concat(MSG, ".run.button") }))),
            React.createElement(Button, { onClick: function () { return runMutation.mutate(true); }, disabled: runDisabled },
                React.createElement(FormattedMessage, { id: "".concat(MSG, ".run.full") }))),
        React.createElement("p", { className: styles.hint },
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".run.full.hint") })),
        saved && (React.createElement(MessageBanner, { type: "success" },
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".schedule.saved") }))),
        running && (React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".run.inProgress") }))),
        React.createElement("h2", { id: "issn-current-run" },
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".currentRun.title") })),
        currentRun ? (React.createElement(CurrentRun, { run: currentRun })) : (React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".currentRun.none") }))),
        React.createElement("h2", { id: "issn-last-run" },
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".lastRun.title") })),
        lastRun ? (React.createElement(LastRun, { run: lastRun })) : (React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "".concat(MSG, ".lastRun.never") })))));
};
